import{createModalContext}from"../modal";export const[WithdrawModalProvider,useWithdrawModalView,useWithdrawModalActions]=createModalContext('Withdraw');